import { CertificationsTrust } from "@/components/CertificationsTrust";
import { Reveal } from "@/components/Reveal";

const PIPELINE = [
  { num: "01", title: "Report check", body: "Every certificate number is verified live against GIA, IGI, or HRD databases before a stone enters our offer list." },
  { num: "02", title: "Inscription match", body: "Laser inscriptions are read and matched to the report under magnification at intake — no paper without the stone to prove it." },
  { num: "03", title: "Origin screen", body: "Natural goods are Kimberley Process compliant and screened against sanctioned-origin lists, with provenance documented." },
  { num: "04", title: "Vault intake", body: "Stones are logged, sealed, and held in bonded JLT vaulting under dual control until carriage or collection." },
];

export const TrustPage = () => (
  <div className="pt-24" data-testid="trust-page">
    <header className="mx-auto max-w-7xl px-6 pb-8 pt-16 lg:px-12">
      <Reveal>
        <p className="eyebrow mb-4">Certifications & Trust</p>
        <h1 className="font-display max-w-3xl text-4xl font-light leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          Trust is the <span className="gold-text italic">only currency</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#B8BCC2] sm:text-lg">
          In this trade, reputation compounds faster than margin. Here is exactly how every stone
          is verified before it reaches your bench.
        </p>
      </Reveal>
    </header>

    <CertificationsTrust />

    <section className="mx-auto max-w-7xl px-6 pb-28 lg:px-12" data-testid="verification-pipeline">
      <Reveal>
        <p className="eyebrow mb-4">Verification pipeline</p>
        <h2 className="font-display max-w-2xl text-3xl font-light text-white sm:text-4xl">
          Four gates. <span className="gold-text italic">No exceptions.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {PIPELINE.map((p, i) => (
          <Reveal key={p.num} delay={i * 0.08}>
            <div className="glass-panel h-full rounded-2xl p-8 transition-all duration-500 hover:border-[#C9A24B]/40 lg:p-10" data-testid={`pipeline-${p.num}`}>
              <span className="font-display text-sm italic tracking-[0.3em] text-[#C9A24B]">Gate {p.num}</span>
              <h3 className="font-display mt-3 text-2xl text-white">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#B8BCC2]">{p.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-10 rounded-2xl border border-white/10 bg-[#141418] p-8" data-testid="kimberley-note">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C9A24B]">Ethical sourcing commitment</p>
          <p className="mt-3 text-sm leading-relaxed text-[#B8BCC2]">
            Sunrays trades exclusively in Kimberley Process certified natural diamonds and disclosed
            lab-grown goods. We do not deal in undocumented parcels, and we decline supply that cannot
            evidence its chain of custody — at any price.
          </p>
        </div>
      </Reveal>
    </section>
  </div>
);
